import React from 'react';
import {LabelProps} from "../models/FormModule";
import {mergeClass} from "../../../utils/htmlUtils";


const Label = ({label, children, className, ...rest}: LabelProps) => {
    return (
        <label className={mergeClass('shared-label', className)} {...rest}>{label ? label : children}</label>
    );
}


export default Label;
